import numeral from 'numeral';

export const formatAmount = (amount, decimals = 2) => {
  const num = Number(amount);

  if (Number.isNaN(num)) return '-';
  if (num === 0) return '0';

  if (num >= 1) return num.toFixed(decimals);
  if (num >= 0.01) return num.toFixed(decimals);
  if (num >= 0.0001) return num.toFixed(Math.max(decimals, 4));

  return num.toExponential(2);
};

export const formatUsd = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

export function formatBalance(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '0';

  const num = Math.round(Number(value));
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fPercent(number) {
  if (number === 0) {
    return '0%';
  }
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function formatCryptoAmount(amount, decimalPlaces = 4) {
  const num = Number(amount);

  if (Number.isNaN(num)) return '0';

  if (Number.isInteger(num)) {
    return num.toString(); // No decimals for integers
  }

  const absNum = Math.abs(num);

  if (absNum >= 1) {
    // Standard decimals for larger numbers
    return num.toFixed(decimalPlaces).replace(/\.?0+$/, '');
  }

  if (absNum >= 0.0001) {
    // Smaller decimals, show up to 6 places
    return num.toFixed(6).replace(/\.?0+$/, '');
  }

  // Very small number, full precision or scientific notation
  return num.toExponential(6);
}

export function toCents(v) {
  // v can be number or string like "8.00"
  const n = Number(v);
  if (!Number.isFinite(n)) return null;
  return Math.round(n * 100); // 8.00 -> 800
}

export function parseToAtomic(amountStr, decimals) {
  const s = String(amountStr ?? '').trim();
  if (!s) return 0n;

  const neg = s.startsWith('-');
  const [wRaw, fRaw = ''] = (neg ? s.slice(1) : s).split('.');

  const w = wRaw === '' ? '0' : wRaw;
  const f = (fRaw + '0'.repeat(decimals)).slice(0, decimals);

  const base = 10n ** BigInt(decimals);
  const atomic = BigInt(w) * base + BigInt(f || '0');

  return neg ? -atomic : atomic;
}

export function formatFromAtomic(amountAtomic, decimals, { trim = true } = {}) {
  const v = BigInt(amountAtomic ?? 0);
  const neg = v < 0n;
  const x = neg ? -v : v;

  const base = 10n ** BigInt(decimals);
  const whole = x / base;
  const frac = (x % base).toString().padStart(decimals, '0');

  const fracOut = trim ? frac.replace(/0+$/, '') : frac;
  const out = fracOut ? `${whole}.${fracOut}` : `${whole}`;
  return neg ? `-${out}` : out;
}

export function quoteAmountAtomicFE({
  amountIn,
  tokenInDecimals,
  tokenOutDecimals,
  tokenInPriceUsd,
  tokenOutPriceUsd,
  feeRateBps,
  networkFeeUsdAtomic = 0n,
  usdDecimals = 6,
  tokenTwo,
}) {
  const inBase = 10n ** BigInt(tokenInDecimals);
  const outBase = 10n ** BigInt(tokenOutDecimals);

  const amountInAtomic = parseToAtomic(amountIn, tokenInDecimals);

  const priceInUsdAtomic = parseToAtomic(tokenInPriceUsd, usdDecimals);
  const priceOutUsdAtomic = parseToAtomic(tokenOutPriceUsd, usdDecimals);

  const inputUsdAtomic = (amountInAtomic * priceInUsdAtomic) / inBase;

  const feeUsdAtomic = (inputUsdAtomic * BigInt(feeRateBps)) / 10_000n;

  const tokenTwoType = String(tokenTwo?.type || '').toLowerCase();

  const isCryptoOut = tokenTwoType === 'crypto';

  const appliedNetworkFeeUsdAtomic = isCryptoOut ? BigInt(networkFeeUsdAtomic || 0n) : 0n;

  const netUsdAtomic = inputUsdAtomic - feeUsdAtomic - appliedNetworkFeeUsdAtomic;

  // console.log('quote debug', {
  //   amountIn,
  //   tokenTwoType,
  //   inputUsdAtomic: inputUsdAtomic.toString(),
  //   feeUsdAtomic: feeUsdAtomic.toString(),
  //   rawNetworkFeeUsdAtomic: String(networkFeeUsdAtomic),
  //   appliedNetworkFeeUsdAtomic: appliedNetworkFeeUsdAtomic.toString(),
  //   netUsdAtomic: netUsdAtomic.toString(),
  // });

  if (netUsdAtomic <= 0n) return 0n;

  return (netUsdAtomic * outBase) / priceOutUsdAtomic;
}
